import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BTable } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { copyDataset } from "@/api/datasets";
import { updateTags } from "@/api/tags";
import { useHistoryStore } from "@/stores/historyStore";
import { rethrowSimple } from "@/utils/simple-error";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import DatasetName from "@/components/Dataset/DatasetName.vue";
import SwitchToHistoryLink from "@/components/History/SwitchToHistoryLink.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetList',
    setup(__props) {
        const historyStore = useHistoryStore();
        const { currentHistoryId } = storeToRefs(historyStore);
        const query = ref("");
        const limit = ref(50);
        const offset = ref(0);
        const message = ref("");
        const loading = ref(true);
        const sortDesc = ref(true);
        const sortBy = ref("update_time");
        const rows = ref([]);
        const messageVariant = ref("danger");
        const fields = ref([
            {
                key: "name",
                sortable: true,
            },
            {
                key: "tags",
                sortable: false,
            },
            {
                label: "History",
                key: "history_id",
                sortable: true,
            },
            {
                key: "extension",
                sortable: true,
            },
            {
                label: "Updated",
                key: "update_time",
                sortable: true,
            },
            {
                key: "context",
                label: "",
                sortable: false,
            },
        ]);
        const showNotFound = computed(() => {
            return !loading.value && rows.value.length === 0 && query;
        });
        const showNotAvailable = computed(() => {
            return !loading.value && rows.value.length === 0 && !query.value;
        });
        async function load(concat = false) {
            loading.value = true;
            try {
                const { data, error } = await GalaxyApi().GET("/api/datasets", {
                    params: {
                        query: {
                            q: ["name-contains"],
                            qv: [query.value],
                            limit: limit.value,
                            offset: offset.value,
                            order: `${sortBy.value}${sortDesc.value ? "-dsc" : "-asc"}`,
                            view: "summary",
                        },
                    },
                });
                if (error) {
                    rethrowSimple(error);
                }
                const datasets = data;
                if (concat) {
                    rows.value = rows.value.concat(datasets);
                }
                else {
                    rows.value = datasets;
                }
            }
            catch (error) {
                onError(error);
            }
            finally {
                loading.value = false;
            }
        }
        async function onCopyDataset(item) {
            const dataset_id = item.id;
            try {
                if (!currentHistoryId.value) {
                    throw new Error("No current history found.");
                }
                await copyDataset(dataset_id, currentHistoryId.value);
                historyStore.loadCurrentHistory();
            }
            catch (error) {
                onError(error);
            }
        }
        async function onShowDataset(item) {
            const { history_id } = item;
            const filters = {
                deleted: item.deleted,
                visible: item.visible,
                hid: item.hid,
            };
            try {
                await historyStore.applyFilters(history_id, filters);
            }
            catch (error) {
                onError(error);
            }
        }
        async function onTags(tags, index) {
            const item = rows.value[index];
            if (item) {
                item.tags = tags;
            }
            try {
                await updateTags(item?.id, "HistoryDatasetAssociation", tags);
            }
            catch (error) {
                onError(error);
            }
        }
        function onQuery(q) {
            query.value = q;
            offset.value = 0;
            load();
        }
        function onSort(props) {
            offset.value = 0;
            sortBy.value = props.sortBy;
            sortDesc.value = props.sortDesc;
            load();
        }
        function onScroll(scroll) {
            const { scrollTop, clientHeight, scrollHeight } = scroll.target;
            if (scrollTop + clientHeight >= scrollHeight) {
                if (offset.value + limit.value <= rows.value.length) {
                    offset.value += limit.value;
                    load(true);
                }
            }
        }
        function onError(msg) {
            message.value = msg;
        }
        onMounted(() => {
            load();
        });
        return { __sfc: true, historyStore, currentHistoryId, query, limit, offset, message, loading, sortDesc, sortBy, rows, messageVariant, fields, showNotFound, showNotAvailable, load, onCopyDataset, onShowDataset, onTags, onQuery, onSort, onScroll, onError, BAlert, BTable, DelayedInput, DatasetName, SwitchToHistoryLink, LoadingSpan, StatelessTags, UtcDate };
    }
});
